export enum FormlyComponent {
  TcInput = 'tc-input',
}
